export default __webpack_public_path__ + "static/media/FireFighting_08.90114cf4.png";